let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("3VL8p")]).then(() => parcelRequire('2K9q0'));